import { render, staticRenderFns } from "./LiveChart.vue?vue&type=template&id=2f72f7e4&"
import script from "./LiveChart.vue?vue&type=script&lang=js&"
export * from "./LiveChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports